import React, { useEffect } from 'react'
import styled from 'styled-components'
import Button from '../shared/Button'
import { useDispatch, useSelector } from 'react-redux'
import { showModal } from '../../features/modal/modalSlice'
import { logoutUser } from '../../features/auth/authSlice'
import { useLocation, useNavigate } from 'react-router-dom'
import { useScrollLock } from '../../hooks/useScrollLock'
import Btn from '../shared/button/Btn'

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: 170px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            padding-bottom: 40px;
        }

        .button-grp{
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }
    }
`
const LogoutVerificationModal = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()
    
        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container>
        <div className="modal">
            <p>Çıkış yapmak istediğinize emin misiniz?</p>
            <div className="button-grp">
                <Btn color={"#E85446"} bgColor={"transparent"} width="260px" handleClick={()=> dispatch(showModal(null))}>Geri dön</Btn>
                <Btn color={"#FFF"} bgColor={"#E85446"} width="260px" handleClick={()=> {dispatch(logoutUser()); navigate("/giris-yap")} }>Çıkış Yap</Btn>
            </div>
        </div>
    </Container>
  )
}

export default LogoutVerificationModal